import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createBotApiKey } from '../../features/bots/services'
import type { BotApiKey } from '../../features/bots/types'

import { useQueryKeys } from '../useQueryKeys'

export function useCreateBotApikey({ workspaceId, botId }: { workspaceId: string; botId: string }) {
  const queryClient = useQueryClient()
  const { listBotApiKeys } = useQueryKeys()

  return useMutation({
    mutationFn: async ({ note }: { note: string }) => createBotApiKey({ workspaceId, botId, note }),
    onSuccess: async (bak) => {
      queryClient.setQueryData<BotApiKey[]>(listBotApiKeys(botId), (baks) => {
        if (!baks) {
          return [bak]
        }

        return [bak, ...baks]
      })
    },
  })
}
